import styles from './pdfPreviewError.module.css';

export interface PdfPreviewErrorProps {
  errorMessage: string;
}

function PdfPreviewError({ errorMessage }: PdfPreviewErrorProps) {
  return (
    <div className={styles.pdfPreviewError}>
      <img width={70} src="/images/Icon-hide-image.svg" alt="" />
      <span>{errorMessage}</span>
    </div>
  );
}

export default PdfPreviewError;
